<script lang="ts" setup>
const props = defineProps({
    product: {
        type: Object,
    },
});

// Data
const config = useRuntimeConfig();

// Get CW resource
let requestURL =
    config.public.CW_API +
    `/resource?api_abc_token=${config.public.CW_API_TOKEN}&resource_id=${props.product?.coursewave_product_id}`;
const { data, error } = await useFetch(requestURL);
let cwResource: object = {};
if (data.value && data.value.resource) {
    cwResource = data.value.resource;
}
// Get CW resource tests
requestURL =
    config.public.CW_API +
    `/resource/tests?api_abc_token=${config.public.CW_API_TOKEN}&resource_id=${props.product?.coursewave_product_id}`;
const { data: response2, error: error2 } = await useFetch(requestURL);
let cwTests: object = {};
if (response2.value && response2.value.tests) {
    cwTests = response2.value.tests.sort((a, b) => a.order - b.order);
}

// Functions
function hasPageSamples(pages: object) {
    let isSample = false;
    pages.forEach((page) => {
        if (page.is_sample) {
            isSample = true;
        }
    });
    return isSample;
}

function ebookPageIsSample(pageNum: number) {
    if (pageNum && cwResource.ebook_sample_pages && cwResource.ebook_sample_pages.length > 0) {
        return cwResource.ebook_sample_pages.includes(pageNum);
    }
    return false;
}
</script>

<template>
    <div>
        <div v-if="cwResource && cwTests.length > 0">
            <h2 class="text-center text-2xl">CourseWave</h2>
            <div class="mt-6 hidden border-b border-gray-300 pb-1 lg:flex">
                <div class="flex-1"></div>
                <div class="flex w-2/6 flex-none text-center">
                    <div class="flex-1">Workbook</div>
                    <div class="flex-1">Sample Question</div>
                </div>
            </div>
            <div v-for="test in cwTests" :key="test.id" class="border-b border-gray-300 py-2 lg:flex">
                <div class="flex-1 leading-tight">{{ test.title }}</div>
                <div class="flex flex-none flex-row-reverse pt-1 text-sm md:flex-row lg:w-2/6 lg:text-center">
                    <div class="flex-1">
                        <a
                            v-if="ebookPageIsSample(test.ebook_page_number)"
                            :href="`${config.public.CW_HOST}/samples/resources/${cwResource.id}/preview-eBook?
                                page=${test.ebook_page_number}`"
                            target="_blank"
                            class="text-abc-blue"
                        >
                            Workbook Preview
                        </a>
                    </div>
                    <div class="flex-1">
                        <a
                            v-if="test.sample_pages_count > 0"
                            :href="`${config.public.CW_HOST}/samples/resources/${cwResource.id}/tests/${test.id}`"
                            target="_blank"
                            class="text-abc-blue"
                        >
                            View Question
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!cwResource" class="py-2 text-center">
            Sorry, we couldn't find the related CourseWave product.
        </div>
        <div v-else class="py-2 text-center">Sorry, there is currently no table of contents.</div>
    </div>
</template>

<style scoped></style>
